<script lang="ts">
  import { Button } from '@shared/ui/button';
  import { walletConnect } from '../model';

  const { connect, isLoading } = walletConnect();
</script>

<Button on:click="{() => connect()}" loading="{$isLoading}">Connect Wallet</Button>
